import { planTypes } from '@/common/constants';
import { defaultMapper } from '@/common/service/default-mapper';
import { planUnitMap } from '@/common/product-unit';

export const ZoomRoomCategories = {
  ZR: 'zr',
};

export default (planMapJSON) => {
  return defaultMapper({
    ...planMapJSON[ZoomRoomCategories.ZR],
    typeNameKey: 'billing.planform.title.zoomroom',
    planNameKey: 'billing.planform.title.zoomroom',
    billingCycleDependBasePlanTypeList: [planTypes.ZOOM_MEETING, planTypes.ZOOM_ONE_BUNDLE, planTypes.ZOOM_UNITED, planTypes.ZONE_PRO_PLUS, planTypes.ZONE_EDU_PLUS],
  }, planTypes.ZOOM_ROOMS).map((p) => {
    return {
      ...p,
      min: 1,
      max: 49,
      unit: planUnitMap.room,
    };
  });
}
